"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeFilter = exports.rawDateFilter = exports.dateFilter = void 0;
var _get_time = _interopRequireDefault(require("date-fns/get_time"));
var _is_within_range = _interopRequireDefault(require("date-fns/is_within_range"));
var _is_date = _interopRequireDefault(require("date-fns/is_date"));
var _get = _interopRequireDefault(require("lodash/get"));
var _add_days = _interopRequireDefault(require("date-fns/add_days"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var typeFilter = exports.typeFilter = function typeFilter(item, selectedType) {
  var value = (0, _get["default"])(item, 'Type');
  if (!value) {
    console.warn('recent activity item does not have a type:', item);
    return false;
  }
  if (selectedType !== 'all') {
    return value === selectedType;
  } else {
    return true;
  }
};
var dateFilter = exports.dateFilter = function dateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var rawTimeStamp = (0, _get["default"])(item, 'TimeStamp.raw');
  if (!rawTimeStamp) {
    console.warn('recent activity item does not have a TimeStamp.raw property:', item);
    return false;
  }
  if ((0, _is_date["default"])(startDate) && (0, _is_date["default"])(endDate)) {
    return (0, _is_within_range["default"])(rawTimeStamp, (0, _get_time["default"])(startDate), (0, _get_time["default"])((0, _add_days["default"])(endDate, 1)));
  }
  return (0, _is_within_range["default"])(rawTimeStamp, 0, Date.now());
};
var rawDateFilter = exports.rawDateFilter = function rawDateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var rawTimeStamp = (0, _get["default"])(item, 'TimeStamp');
  if (!rawTimeStamp) {
    console.warn('recent activity item does not have a TimeStamp property:', item);
    return false;
  }
  if ((0, _is_date["default"])(startDate) && (0, _is_date["default"])(endDate)) {
    return (0, _is_within_range["default"])(rawTimeStamp, (0, _get_time["default"])(startDate), (0, _get_time["default"])((0, _add_days["default"])(endDate, 1)));
  }
  return (0, _is_within_range["default"])(rawTimeStamp, 0, Date.now());
};